export default {
  OK: 0,
  GENERIC_ERROR: 1,
  INVALID_ACCESS_TOKEN: 2,
  MANAGE_PAGES_NOT_ALLOWED: 3
}
